import goTopButton from '@/components/GoTopButton'

import { showProductDetails, showAccountDetails, showCardDetails, showOrderDetails } from '@/tools/utils.js'

export default {

  components: {
    goTopButton
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      responseErr: null,
      isProcessing: false,
      beneficiaryService: null
    }
  },

  created () {
    this.beneficiaryService = this.$store.state.beneficiaries.beneficiaryService
    if (!this.beneficiaryService) {
      this.$store.dispatch('beneficiaries/invalidData', 'BENEFICIARY_SERVICE_EMPTY')
      this.$router.push({ name: 'beneficiaryservice-list' })
    }
    else {
      this.$store.dispatch('beneficiaries/resetInvalidData')
      this.getDetail()
    }
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('beneficiaries/detail', {
        beneficiaryServiceRef: this.beneficiaryService.beneficiaryServiceRef,
        distributorRef: this.beneficiaryService.distributorRef,
        funderContractRef: this.beneficiaryService.funderContractRef,
        issuerId: this.getIssuerId(this.beneficiaryService.distributorRef)
      }).then(
        () => {
          this.isProcessing = false
          this.bsDetail = this.$store.state.beneficiaries.bsDetail
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    showProduct (productExternalReference) {
      this.$store.dispatch('products/setProduct',{
        prb1: productExternalReference,
        prb7: this.beneficiaryService.distributorRef
      })
      return showProductDetails()
    },

    showCard (card) {
      this.$store.dispatch('cards/setCard', { card: card })
      return showCardDetails()
    },

    showAccount (accountDetailsPageContext) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountDetailsPageContext[0],
        distributorRef: this.beneficiaryService.distributorRef,
        beneficiaryServiceRef: accountDetailsPageContext[2],
        issuerId: accountDetailsPageContext[1],
        singleFunderAccount: this.$store.state.beneficiaries.bsDetail.singleFunderAccount
      })
      return showAccountDetails()
    },

    showOrder (order) {
      this.$store.dispatch('orders/setOrder', order)
      return showOrderDetails()
    }

  }
}
